import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';
import { OnlineCourseDetails } from './online-course-details.type';

/**
 * Type representing the complete course summary data
 * Used by CourseSummaryComponent to display course information and pricing
 */
export interface CourseSummary {
  courseDetails?: OnlineCourseDetails;
  selectedDuration?: number;
  selectedStartDate?: string;
  selectedEndDate?: string;
  grandTotal?: LimitedCurrencyAmount[];
  currency?: string;
}
